import { ReactNode } from "react"

export interface StepsBreadcrumbStep {
    step: number
    label: ReactNode
    ariaLabel?: string
}

interface StepsBreadcrumbProps {
    steps: StepsBreadcrumbStep[]
    currentStep: number
    onStepClick?: (step: number) => void
    isStepClickable?: (step: number) => boolean
}

export default function StepsBreadcrumb({ steps, currentStep, onStepClick, isStepClickable }: StepsBreadcrumbProps) {
    if (steps.length === 0) {
        return null
    }

    const activeIndex = steps.reduce((acc, breadcrumb, index) => (currentStep >= breadcrumb.step ? index : acc), 0)

    return (
        <div className="w-full text-pale">
            <div className="flex items-center gap-[2px] lg:gap-[10px] py-[10px]">
                {steps.map((breadcrumb, index) => {
                    const clickable = !!onStepClick && (isStepClickable?.(breadcrumb.step) ?? true)
                    const colorClass = index <= activeIndex ? "bg-rm-orange" : "bg-[#d7d7d7]"
                    const stepName =
                        breadcrumb.ariaLabel ??
                        (typeof breadcrumb.label === "string" ? breadcrumb.label : `étape ${index + 1}`)

                    if (!clickable) {
                        return (
                            <div
                                key={breadcrumb.step}
                                className={`h-[7px] flex-1 rounded-full transition-colors duration-300 ${colorClass}`}
                            />
                        )
                    }

                    return (
                        <button
                            key={breadcrumb.step}
                            type="button"
                            aria-label={`Aller à l'étape ${index + 1} : ${stepName}`}
                            onClick={() => onStepClick(breadcrumb.step)}
                            className={`h-[7px] flex-1 rounded-full transition-all duration-300 cursor-pointer hover:opacity-70 ${colorClass}`}
                        />
                    )
                })}
            </div>
            <div className="flex items-center justify-between text-rm-10 lg:text-base">
                <span>
                    Étape {activeIndex + 1} sur {steps.length}
                </span>
                <span>{steps[activeIndex].label}</span>
            </div>
        </div>
    )
}
